// extracted by mini-css-extract-plugin
export default {"headerBox":"index_headerBox_LzmXi","container":"index_container_pR-GO","searchBox":"index_searchBox_QjR0H"};